<div class="d-flex justify-content-center bd-highlight">
  <div class="p-2 bd-highlight">
    @if (!isNew) {
      <div>
        <button class="btn custom-button" (click)="save()" i18n>
                {{'general.save' | translate}}
            </button>
      </div>
    }

    @if (isNew) {
      <div>
        <button class="btn custom-button" (click)="save()" i18n>
                {{'general.create' | translate}}
            </button>
      </div>
    }
  </div>

</div>